/* batida-v7-horeca.js: /pages/horeca of the new batida.pl (sections/batida-v7-horeca-*). Small and optional:
   - "Dla kogo pieczemy?" tabs (click + arrow keys),
   - "Ludzie mówią" quotes (dots; change by themselves unless the visitor asked for less motion),
   - buttons with data-v7r-go scroll to the form and pick the matching segment there (data-v7r-topic also writes
     "Temat: …" into the message: "Umów degustację" when the b2b.batida.pl booking link is emptied),
   - the "30+" number counts up once it is on screen.
   The contact form itself is a plain Shopify form with a normal submit - this file never touches it (Shopify's spam
   check on contact forms stays as it is). Works again after the theme editor reloads a section. */
(function () {
  'use strict';
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  function all(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function initTabs(list) {
    if (list.__v7r) return; list.__v7r = 1;
    var tabs = all('[role="tab"]', list);
    function select(i, focus) {
      tabs.forEach(function (t, j) {
        var on = i === j;
        t.setAttribute('aria-selected', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        var p = document.getElementById(t.getAttribute('aria-controls'));
        if (p) p.hidden = !on;
      });
      if (focus) tabs[i].focus();
      if (list.scrollWidth > list.clientWidth + 2) {
        list.scrollTo({ left: Math.max(0, tabs[i].offsetLeft - 24), behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { select(i); });
      t.addEventListener('keydown', function (e) {
        var n = null;
        if (e.key === 'ArrowRight') n = (i + 1) % tabs.length;
        else if (e.key === 'ArrowLeft') n = (i - 1 + tabs.length) % tabs.length;
        else if (e.key === 'Home') n = 0;
        else if (e.key === 'End') n = tabs.length - 1;
        if (n !== null) { e.preventDefault(); select(n, true); }
      });
    });
    list.__v7rSelect = select;
  }

  function initQuotes(box) {
    if (box.__v7r) return; box.__v7r = 1;
    var figs = all('.v7r-q__f', box), dots = all('.v7r-q__dot', box);
    if (figs.length < 2) return;
    var cur = 0, timer = null, paused = false;
    var every = parseInt(box.getAttribute('data-every'), 10) || 0;
    function show(n) {
      cur = (n + figs.length) % figs.length;
      figs.forEach(function (f, i) { f.hidden = i !== cur; });
      dots.forEach(function (d, i) { d.setAttribute('aria-pressed', i === cur ? 'true' : 'false'); });
    }
    function restart() {
      clearInterval(timer);
      if (!every || reduce) return;
      timer = setInterval(function () { if (!paused && !document.hidden) show(cur + 1); }, every * 1000);
    }
    dots.forEach(function (d, i) { d.addEventListener('click', function () { show(i); restart(); }); });
    box.addEventListener('mouseenter', function () { paused = true; });
    box.addEventListener('mouseleave', function () { paused = false; });
    box.addEventListener('focusin', function () { paused = true; });
    box.addEventListener('focusout', function () { paused = false; });
    box.__v7rShow = function (n) { show(n); restart(); };
    restart();
  }

  function initCount(el) {
    if (el.__v7r) return; el.__v7r = 1;
    var to = parseInt(el.getAttribute('data-v7r-count'), 10);
    if (!to || reduce || !('IntersectionObserver' in window)) return;
    el.textContent = '0';
    var io = new IntersectionObserver(function (es) {
      if (!es[0].isIntersecting) return;
      io.disconnect();
      var t0 = performance.now();
      (function step(now) {
        var p = Math.min(1, (now - t0) / 1200);
        el.textContent = Math.round(to * (1 - Math.pow(1 - p, 3)));
        if (p < 1) requestAnimationFrame(step);
      })(t0);
    }, { threshold: 0.6 });
    io.observe(el);
  }

  // 6.10 tab photos: hidden tabs' photos carry loading="lazy" + class v7h-ph__defer, which the browser's lazy loader never fetches
  // (display:none). On the window load event they turn eager, so every tab's photo is already there when it is clicked.
  // Photos that finished before this script ran get their fade-in class here (the img's own onload covers the rest).
  function initPhotos(root) {
    all('.v7h-ph--lq img', root).forEach(function (im) {
      if (im.complete) im.parentNode.classList.add('is-ld');
    });
  }
  function eagerPhotos() {
    all('img.v7h-ph__defer').forEach(function (im) {
      im.classList.remove('v7h-ph__defer');
      im.loading = 'eager';
    });
  }
  if (document.readyState === 'complete') eagerPhotos();
  else window.addEventListener('load', eagerPhotos);

  function init(root) {
    initPhotos(root);
    all('[data-v7r-tabs]', root).forEach(initTabs);
    all('[data-v7r-quotes]', root).forEach(initQuotes);
    all('[data-v7r-count]', root).forEach(initCount);
  }

  // "Zapytaj o ofertę" / "Umów degustację": scroll to the form and pick the segment
  document.addEventListener('click', function (e) {
    var a = e.target.closest ? e.target.closest('[data-v7r-go]') : null;
    if (!a) return;
    var sec = document.getElementById('v7r-form');
    if (!sec) return;
    e.preventDefault();
    var seg = (a.getAttribute('data-v7r-go') || '').trim().toLowerCase();
    if (seg) {
      all('.v7r-f__segs input[type="radio"]', sec).forEach(function (r) {
        if (r.value.trim().toLowerCase() === seg) r.checked = true;
      });
    }
    // F23: "Umów degustację" without the booking link: "Temat: Degustacja" as the message's first line (once)
    var topic = (a.getAttribute('data-v7r-topic') || '').trim(), msg = sec.querySelector('textarea[name="contact[body]"]');
    if (topic && msg) {
      var line = 'Temat: ' + topic, lines = msg.value ? msg.value.split('\n') : [];
      if (lines[0] && lines[0].indexOf('Temat: ') === 0) lines[0] = line; else lines.unshift(line);
      msg.value = lines.join('\n').replace(/\n+$/, '') + '\n';
    }
    sec.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
  });

  // theme editor: re-init a reloaded section, show the tab / quote whose block is selected
  document.addEventListener('shopify:section:load', function (e) { init(e.target); eagerPhotos(); });
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (!el || !el.classList) return;
    if (el.classList.contains('v7r-pane')) {
      var tab = document.getElementById(el.getAttribute('aria-labelledby'));
      var list = tab && tab.closest('[data-v7r-tabs]');
      if (list && list.__v7rSelect) list.__v7rSelect(all('[role="tab"]', list).indexOf(tab));
    } else if (el.classList.contains('v7r-q__f')) {
      var box = el.closest('[data-v7r-quotes]');
      if (box && box.__v7rShow) box.__v7rShow(all('.v7r-q__f', box).indexOf(el));
    }
  });

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
})();
